import store from 'src/store';
import { getActiveContract, getContractsOfUserForPeriod, getContractTypeName, getPrimaryProfessionName } from 'src/helpers/modular/employeesContractsUtil';
import { selectEmployeesContractsList } from 'src/store/selectors/employeesContracts';
export function getEventsWithContract(eventsData, period) {
    const allContractsMap = selectEmployeesContractsList(store.getState());
    return eventsData.map(({ User, ...other }) => {
        const userContracts = getContractsOfUserForPeriod(allContractsMap, User.UserId, period);
        const activeContract = getActiveContract(userContracts, true);
        return ({
            ...other,
            User,
            UserContracts: userContracts,
            activeContract: !activeContract ? null : {
                ...activeContract,
                contractTypeName: getContractTypeName(+activeContract.contractTypeId) || null,
                primaryProfessionName: getPrimaryProfessionName(activeContract)
            }
        });
    });
}
